/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendProjectConfigDto } from '../../models/backend-project-config-dto';
import { BackendProjectConfigRequestDto } from '../../models/backend-project-config-request-dto';

export interface ProjectsProjectConfigUpdate$Params {
  id: number;
  body?: BackendProjectConfigRequestDto;
}

export function projectsProjectConfigUpdate(
  http: HttpClient,
  rootUrl: string,
  params: ProjectsProjectConfigUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendProjectConfigDto>> {
  const rb = new RequestBuilder(rootUrl, projectsProjectConfigUpdate.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendProjectConfigDto>;
    }),
  );
}

projectsProjectConfigUpdate.PATH = '/api/projects/project-config/{id}/';
